//import node_modules
import React, { FunctionComponent } from "react";
import { Container, Row } from "react-bootstrap";
import { If, Then, Else } from "react-if";

//libs
import { cx, css } from "libs/emotion";
import { BREAKPOINTS } from "@adjust/website/src/styles/shared";

//components
import ImageComponent from "./ImageComponent";
import InformationComponent from "./InformationComponent";
import PageHeaderComponent from "src/components/PageHeaderComponent";

//types
import type { BlogDocument } from "@adjust/libs/database/blogs";

type BlogsProps = {
  blogs: BlogDocument[];
};

const postCSS = css({
  paddingBottom: "1em",
  ["& + &"]: {
    paddingTop: "1em",
  },
  [BREAKPOINTS.lg]: {
    paddingBottom: "2em",
    ["& + &"]: {
      paddingTop: "2em",
    },
  },
});

const BlogsComponent: FunctionComponent<BlogsProps> = ({ blogs }) => {
  return (
    <Container className="my-5">
      <PageHeaderComponent type="h1" className="text-center">
        Adjust To The Good Life Travel Blog
      </PageHeaderComponent>
      <hr className="my-4" />
      {blogs.map((blog, i) => (
        <Row key={blog.slug} className={cx(postCSS, "justify-content-center g-0")}>
          <If condition={i % 2 === 0}>
            <Then>
              <ImageComponent order={1} blog={blog} index={i} />
              <InformationComponent order={2} blog={blog} />
            </Then>
            <Else>
              <InformationComponent order={1} blog={blog} />
              <ImageComponent order={2} blog={blog} index={i} />
            </Else>
          </If>
        </Row>
      ))}
    </Container>
  );
};

export default React.memo(BlogsComponent);
